import React from 'react'

import Link from '@material-ui/core/Link'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  poweredBy: {
    alignItems: 'center',
    borderRadius: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    height: theme.spacing(6),
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(0, 2),
    position: 'fixed',
    right: 0,
    zIndex: 1000,
  },
  poweredByText: {},
  poweredByLink: {
    fontWeight: 'bold',
  },
})
const useStyles = makeStyles(styles)

export default function ApplicationPoweredBy() {
  const classes = useStyles()

  return (
    <Paper className={classes.poweredBy} elevation={4}>
      <Typography className={classes.poweredByText} variant="body1">
        Powered by{' '}
        <Link
          className={classes.poweredByLink}
          href="https://paniclobster.com/"
          target="_blank"
        >
          Panic Lobster
        </Link>
      </Typography>

      <Typography className={classes.poweredByText} variant="body2">
        <Link href="https://privacidade.grupoboticario.com.br/" target="_blank">
          Política de Privacidade
        </Link>
        {' - '}
        <Link
          href="https://portaldeprivacidade.grupoboticario.com.br/"
          target="_blank"
        >
          Exerça seus Direitos
        </Link>
      </Typography>
    </Paper>
  )
}
